import { store } from '@/store';
import browser from '@/utils/browser';
import router from '@/router';
import insurance from '@/utils/insurance';

const payment = {
    carPayment(data){
        axios.post(apiUrl.CarPayment, data, {
            headers: {'Auth': store.state.auth.token}
        }).then(res => {
            if (res.data.Code === 200) {

                // 街口或全支付 直接跳轉出去付款
                if(res.data.Data.CarPolicy.Trade.PaymentUrlByTappay){
                    const payway = res.data.Data.CarPolicy.Trade.PayWay == 19 ? '街口' : '全';
                    store.commit('setDialog', {
                        type: 'info',
                        text: `提醒您：尚未付款完成，將導向到「${payway}支付」進行付款，請勿關閉視窗。付款完成後會自動進入下一步驟。`,
                        active: true,
                        closeFunc: () => {
                            store.commit('clearDialog');
                            window.removeEventListener('beforeunload', browser.leavePageAlert);
                            return window.location.href = DOMPurify.sanitize(res.data.Data.CarPolicy.Trade.PaymentUrlByTappay, {KEEP_CONTENT: false});
                        },
                    });
                    store.commit('closeLoading');
                    return;
                } else {

                    // 如果有繳款方式，是非馬上付款完成的，這裡就不能設 true
                    store.commit('policy/setPaid', true);

                    store.commit('policy/setCompleteMessage',res.data.Data.CompleteMessage);
                    store.commit('policy/requireProposal', res.data.Data.IsRequireProposal);

                    // 儲存 policy 資料
                    store.commit('estimate/setData', res.data.Data.CarPolicy.Estimate);
                    store.commit('hccs/setData', res.data.Data.CarPolicy.Hccs);
                    store.commit('policy/setSalePrice', store.state.estimate.PremiumChoice + store.state.estimate.PremiumCompel);

                    // 清掉 store 的 insure selected
                    store.commit('unselectInsurances');

                    // 儲存 response 的保險資料進 store
                    insurance.setPolicyInsuresFromApi(res.data.Data.CarPolicy.Insures);


                    if (store.state.policy.entry === 'lookup') {
                        if (store.state.policy.isRenew) return router.push(`/${router.currentRoute.value.params.type}/lookup/renew/checkout/finish`);
                        return router.push(`/${router.currentRoute.value.params.type}/lookup/checkout/finish`);
                    }

                    return router.push(`/${router.currentRoute.value.params.type}/checkout/finish`);
                }
            } else {
                store.commit('setDialog', {
                    title: '付款失敗',
                    text: res.data.ErrMessage,
                    active: true
                });
                store.commit('closeLoading');
            }

        }).catch(err => {
            console.log(err);
            var errMessage = '';
            if(err.response){
                errMessage = err.response.data.ErrMessage;
            }
            else{
                errMessage = '系統忙碌中，請稍後再試';

                // let body = 'estimateID: ' + store.state.estimate.EstimateId + 
                //     '; Clairty Id: ' + store.state.estimate.ClarityId + 
                //     '; error: ' + (err.message ? err.message : '無法取得錯誤訊息。');

                // let errData = {
                //     Subject: '繳費異常',
                //     Body: body,
                // };

                // axios.post(apiUrl.SendClientError, errData).catch(err=>{});
            }
            store.commit('setDialog', {
                title: '付款失敗',
                text: errMessage,
                active: true
            });
            store.commit('closeLoading');
        });
    }
};

export default payment;